module.exports = __webpack_public_path__ + "static/media/04.ade7e0bb.jpg";